import type { NetSuiteSyncInvoicesRequestPayload } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import { queryKeys } from '../../../../services/query-key/query-keys';

export function useSyncNetSuiteInvoice(
  options?: UseMutationOptions<void, unknown, NetSuiteSyncInvoicesRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (netSuiteSyncInvoicesRequest) => {
      const api = getPrivateApi();

      return api.netSuiteSyncInvoices({
        netSuiteSyncInvoicesRequest,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries(queryKeys.jobs());
    },
    ...options,
  });
}
